class Cookie {
    public static WECHATIDKEY = 'wechat_id'
    public static NECAPTCHAVALIDATE = 'NECaptcha_validate'
    public static NECAPTCHAEXPIRATIONTIME = 'NEcaptcha_expiration_time'

    public static get(key: string = this.KEY) {
        const reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
        const arr = document.cookie.match(reg)
        if (arr) {
            return arr[2]
        } else {
            return ''
        }
    }

    public static set(
        value: string,
        key: string = this.KEY,
        domain: string = this.DOMAIN,
        time: number = this.TIME,
        path: string = this.PATH
    ) {
        let cookie = key + '=' + encodeURIComponent(value)
        const date = new Date()
        date.setTime(date.getTime() + time)
        cookie += ';expires=' + date.toUTCString()
        cookie += ';domain=' + (domain ? domain : this.DOMAIN)
        cookie += ';path=' + (path ? path : this.PATH)
        document.cookie = cookie
    }

    private static DOMAIN = '.smm.cn'
    private static TIME = 3 * 24 * 60 * 60 * 1000
    private static PATH = '/'
    private static KEY = 'SMM_auth_token'
}

export {
    Cookie
}


// WEBPACK FOOTER //
// ./src/utils/cookie.ts